import React from 'react';
import { Link } from 'react-router-dom';
import dp from '../assets/dp.png';
import searchvec from '../assets/sub.svg'
const MyAccPaymentComp = () => {
  return (  
    <>
              <div className='mb-24'>
        <div className='md:mt-6   container mx-auto'>
          {/* serach bar */}
    
      
          <div className='flex w-[95%] mx-auto border border-gray-200 rounded-full'>
          <img src={searchvec} alt='imgg' className=' ml-3 mt-3 h-[25px] w-[35px]'  />
        <input className='w-full ml-3 h-12 bg-[#FBFEFF] rounded-full pl-3 outline-none reltive md:text-base text-xs ' type='text' placeholder='Search a padel court to book' />
        <div className='bg-blue-100 h-12 w-16 pt-2 cursor-pointer rounded-r-full -ml-16'>
        <i class="fa-solid fa-location-crosshairs text-blue-600 ml-4 text-2xl"></i>
   
        </div> 
        </div>

        {/* account pic password and number */}

        <div className='w-[95%] mx-auto'>
                 <div className='md:flex m-3 justify-between mx-auto border border-gray-300 rounded-xl p-8 md:mt-6'>
                    {/* pic name */}
               <div className='pic-name md:flex'>
                 <div className='profile-pic flex '>
                   <img src={dp} alt='dp' className=' rounded-full  h-[5rem] md:h-[124px]' />
                   <div className=' h-[33px] w-[33px]  bg-[#e2edfb] rounded-full mt-[3rem] md:mt-20 -ml-7 '> 
                   <input type="file" id="bizimg" class="shadow-sm px-4 hidden h-[40px]  border border-gray-300 text-gray-900 text-xs rounded-2xl   h-[50px]  w-full p-2.5 focus:bg-white   " placeholder='Enter password' required />
               
                   <label htmlFor="bizimg" className='text-[12px] bg-[#e2edfb]   cursor-pointer ml-[10px]  mt-[10px]  h-8 w-8 rounded-full text-[#6A7D95] text-center  ' ><i class="fa-solid fa-pencil text-blue-500 cursor-pointer  text-base mt-[3px] "  ></i></label>
                   </div>
                 </div>
                 <div className='name  md:pl-3  flex md:justify-center md:items-center '>
                   <div>
                     <h1 className='text-2xl text-[#272C34]  font-bold'>John Doe</h1>
                     <p className='text-xs text-[#6A7D95]'>Johndoe@gmail.com</p>
                   </div>
                   <div> 
                   <i class="fa-solid fa-pencil text-blue-500 cursor-pointer mx-3"></i>
                   </div>
                 </div>
               </div>

               {/* password */}


               <div className='password  pt-4 flex'>
                  
                  <div className='passsword md:mx-3  flex justify-center items-center '>
                    <div>
                      <h1 className='text-2xl text-[#272C34] font-bold'>Password</h1>
                      <p className='text-xs text-[#6A7D95]'>*******************</p>
                    </div>
                    <div> 
                    <i class="fa-solid fa-pencil text-blue-500 cursor-pointer mx-3"></i>
                    </div>
                  </div>
                </div>
 

                 </div>
               </div>

               {/* My booking in account */}

            <div className='main md:w-[90%]  mx-auto'> 
            <div className='account-wrap lg:flex  md:flex'>



            <div className='md:w-[20%] w-[60%] '>
            <div className='ml-3'>
            <h1 className='text-2xl text-[#272C34] font-bold'>Profile</h1>
            <p className='text-gray-500 cursor-pointer py-1 text-lg '> <Link to="/MyAccount" >My Bookings</Link> </p>
            <p className='text-[#409BF5] cursor-pointer py-1 text-lg  '><Link to="/MyAccPayment" > Payment method </Link></p>
            <p className='text-gray-500 cursor-pointer py-1 text-lg '><Link to="/Notifi" > Notification </Link></p>
            </div>
            </div>

            <div className='w-full'>
            <div>
            <h1 className='text-2xl ml-3  text-[#272C34] font-bold'>Payment Method</h1>
            <div className='my-4 md:w-[70%] '>
              <div className='mybookings-img'>
                 <div className='account-form mx-3 '>
                 <div className=' w-full '>

<form >
<div class="mb-6">
<label for="email" class="block mb-2 text-xs font-normal text-[#131436]  ">Name on card</label>
<input type="text" id="email" class="shadow-sm h-[50px]  bg-[#FBFEFF] border border-gray-300 text-[#6A7D95]  text-xs rounded-xl focus:border-blue-500 block w-full p-2.5 " placeholder="Enter your name on card" required/>
</div>
<div class="mb-6">
<label for="email" class="block mb-2 text-xs font-normal text-[#131436]"> Card Number</label>
<input type="text" id="email" class="shadow-sm h-[50px]  bg-[#FBFEFF] border border-gray-300 text-[#6A7D95]  text-xs rounded-xl   focus:border-blue-500 block w-full p-2.5 " placeholder="Enter your card number" required/>
</div>
<div class="mb-6">
<label for="email" class="block mb-2 text-xs font-normal text-[#131436]">Expiration Date</label>
<input type="date" id="email" class="shadow-sm h-[50px]  bg-[#FBFEFF] border border-gray-300 text-[#6A7D95]  text-xs rounded-xl   focus:border-blue-500 block w-full p-2.5 " placeholder="MM/YY" required/>
</div>
<div class="mb-6">
<label for="password" class="block mb-2 text-xs font-normal text-[#131436]">CVV</label>
<input type="text" id="password" class="shadow-sm h-[50px]  bg-[#FBFEFF] border border-gray-300 text-[#6A7D95]  text-xs rounded-xl focus:  focus:border-blue-500 block w-full p-2.5  " placeholder='CVV' required/>
</div>
<div class="mb-6"> 
<button type="submit" class="text-white float-right md:my-6  bg-[#409BF5] hover:bg-blue-500    font-medium rounded-lg text-sm px-16 h-[50px] text-center  ">Save</button>
</div>

 

</form>
</div>
                 </div>               
              </div>
 
            </div>
            </div>
            </div>








            </div>
            </div>



        </div>
      </div>  
    </>
  )
}

export default MyAccPaymentComp